var map = {
	"./test/config.json": 390,
	"./test/default/17/config.json": 391,
	"./test/default/config.json": 392,
	"./test/helpers-env/config.json": 393,
	"./test/some-env/17/config.json": 394,
	"./test/some-env/config.json": 395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1036;